const pl = {
  brand: "E2 Care",
  tagline: "Spokojna, połączona opieka.",
  nav_dashboard: "Pulpit",
  nav_residents: "Pacjenci",
  nav_patients: "Pacjenci",
  nav_rooms: "Pokoje",
  nav_devices: "Urządzenia",
  nav_events: "Zdarzenia",
  nav_alerts: "Alerty",
  nav_users: "Zespół",
  nav_settings: "Ustawienia",
  nav_admin: "Administracja",
  nav_signout: "Wyloguj się",
  topbar_search_placeholder: "Szukaj pacjentów, pokoi, urządzeń…",
  admin_super_only: "Tylko superadministratorzy mogą zarządzać organizacjami.",
  admin_admin_only: "Tylko administratorzy mają dostęp do tej strony.",
  admin_tab_orgs: "Organizacje",
  admin_tab_users: "Użytkownicy",
  admin_tab_patients: "Pacjenci",
  admin_tab_rooms: "Pokoje",
  admin_tab_buildings: "Budynki",
  admin_tab_devices: "Urządzenia",
  admin_tab_alerts: "Alerty",
  admin_tab_qa: "Narzędzia testowe",
  admin_delete: "Usuń",
  admin_no_orgs_yet: "Brak organizacji.",
  admin_field_name: "Nazwa",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefon",
  admin_field_password: "Hasło",
  admin_field_role: "Rola",
  admin_field_type: "Typ",
  admin_field_timezone: "Strefa czasowa",
  admin_field_address: "Adres",
  admin_field_status: "Status",
  admin_field_organization: "Organizacja",
  admin_password_keep: "Pozostaw puste, aby zachować obecne",
  admin_field_birth_date: "Data urodzenia",
  admin_field_room: "Pokój",
  admin_field_room_none: "Nieprzypisany",
  admin_field_photo: "URL zdjęcia",
  admin_field_photo_hint: "Wklej publiczny adres URL obrazu — pełne przesyłanie w wersji 2.",
  admin_field_notes: "Notatki opiekuna",
  admin_field_emergency_contact: "Główny kontakt awaryjny",
  admin_field_ec_name: "Imię i nazwisko",
  admin_field_ec_phone: "Telefon",
  admin_field_ec_relationship: "Pokrewieństwo",
  admin_field_mac: "Adres MAC",
  admin_field_firmware: "Oprogramowanie",
  admin_field_assignment: "Przypisane do",
  admin_field_assigned_room: "Przypisany pokój",
  admin_field_assigned_patient: "Przypisany pacjent",
  admin_field_assigned_hint: "Opcjonalne. Czujniki zwykle przypisuje się do pokoju, opaski do pacjenta.",
  admin_field_sensor_target: "Zamontowany na",
  admin_field_sensor_target_hint: "Informuje system, czy ten czujnik obserwuje drzwi czy okno.",
  sensor_target_door: "Drzwi",
  sensor_target_window: "Okno",
  sensor_target_unset: "Nie skonfigurowano",
  admin_field_sensor_label: "Etykieta czujnika",
  admin_field_sensor_label_hint: "Przyjazna nazwa wyświetlana w alertach i zdarzeniach — np. „Drzwi wejściowe”, „Okno łazienki”.",
  admin_field_building: "Budynek",
  admin_field_building_required: "Pokój musi należeć do budynku.",
  room_openings: "Otwory",
  room_no_openings: "W tym pokoju nie zainstalowano jeszcze czujników drzwi ani okien.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Ostatnia zmiana",
  admin_field_description: "Opis",
  admin_field_severity: "Ważność",
  admin_field_patient: "Pacjent",
  admin_field_device: "Urządzenie",
  admin_field_message: "Wiadomość",
  admin_orgs_title: "Organizacje",
  admin_orgs_sub: "Twórz, edytuj i archiwizuj najemców E2 Care.",
  admin_orgs_count: "organizacje",
  admin_org_new: "Nowa organizacja",
  admin_org_new_title: "Nowa organizacja",
  admin_org_edit_title: "Edytuj organizację",
  admin_org_created: "Utworzono organizację.",
  admin_org_updated: "Zaktualizowano organizację.",
  admin_org_deleted: "Zarchiwizowano organizację.",
  admin_org_delete_title: "Zarchiwizować organizację?",
  admin_org_delete_confirm: "To ukryje „{name}” na listach. W razie potrzeby można ją przywrócić z bazy danych.",
  admin_users_title: "Użytkownicy",
  admin_users_sub_super: "Zarządzaj wszystkimi kontami użytkowników u wszystkich najemców.",
  admin_users_sub_org: "Zarządzaj kontami użytkowników dla {org}.",
  admin_user_new: "Nowy użytkownik",
  admin_user_new_title: "Nowy użytkownik",
  admin_user_edit_title: "Edytuj użytkownika",
  admin_user_created: "Utworzono użytkownika.",
  admin_user_updated: "Zaktualizowano użytkownika.",
  admin_user_deleted: "Zarchiwizowano użytkownika.",
  admin_user_delete_title: "Zarchiwizować użytkownika?",
  admin_user_delete_confirm: "„{name}” utraci dostęp. Aktywne sesje nie są zamykane.",
  admin_user_memberships: "Członkostwa w organizacjach",
  admin_patients_title: "Pacjenci",
  admin_patients_sub_super: "Zarządzaj wszystkimi kartami pacjentów u wszystkich najemców.",
  admin_patients_sub_org: "Zarządzaj kartami pacjentów w {org}.",
  admin_patient_new: "Nowy pacjent",
  admin_patient_new_title: "Nowy pacjent",
  admin_patient_edit_title: "Edytuj pacjenta",
  admin_patient_created: "Utworzono pacjenta.",
  admin_patient_updated: "Zaktualizowano pacjenta.",
  admin_patient_deleted: "Zarchiwizowano pacjenta.",
  admin_patient_delete_title: "Zarchiwizować pacjenta?",
  admin_patient_delete_confirm: "„{name}” zostanie ukryty na listach. Powiązania z zespołem opieki i rodziną są zachowane.",
  admin_rooms_title: "Pokoje",
  admin_rooms_sub_super: "Konfiguruj pokoje u wszystkich najemców.",
  admin_rooms_sub_org: "Konfiguruj pokoje w {org}.",
  admin_room_new: "Nowy pokój",
  admin_room_new_title: "Nowy pokój",
  admin_room_edit_title: "Edytuj pokój",
  admin_room_created: "Utworzono pokój.",
  admin_room_updated: "Zaktualizowano pokój.",
  admin_room_deleted: "Zarchiwizowano pokój.",
  admin_room_delete_title: "Zarchiwizować pokój?",
  admin_room_delete_confirm: "„{name}” zostanie ukryty. Istniejący pacjenci zachowują odniesienie assigned_room_id.",
  admin_devices_title: "Urządzenia",
  admin_devices_sub_super: "Udostępniaj urządzenia Moko u wszystkich najemców.",
  admin_devices_sub_org: "Udostępniaj urządzenia Moko w {org}.",
  admin_device_new: "Nowe urządzenie",
  admin_device_new_title: "Nowe urządzenie",
  admin_device_edit_title: "Edytuj urządzenie",
  admin_device_created: "Utworzono urządzenie.",
  admin_device_updated: "Zaktualizowano urządzenie.",
  admin_device_deleted: "Zarchiwizowano urządzenie.",
  admin_device_delete_title: "Zarchiwizować urządzenie?",
  admin_device_delete_confirm: "Urządzenie {mac} zostanie ukryte. Wcześniejsze zdarzenia i alerty pozostają w historii.",
  admin_buildings_title: "Budynki",
  admin_buildings_sub_super: "Grupuj pokoje według fizycznego budynku / skrzydła u wszystkich najemców.",
  admin_buildings_sub_org: "Grupuj pokoje według fizycznego budynku / skrzydła w {org}.",
  admin_building_new: "Nowy budynek",
  admin_building_new_title: "Nowy budynek",
  admin_building_edit_title: "Edytuj budynek",
  admin_building_created: "Utworzono budynek.",
  admin_building_updated: "Zaktualizowano budynek.",
  admin_building_deleted: "Zarchiwizowano budynek.",
  admin_building_delete_title: "Zarchiwizować budynek?",
  admin_building_delete_confirm: "„{name}” zostanie ukryty. Pokoje zachowują odniesienie corpus_id.",
  admin_qa_title: "Narzędzia testowe",
  admin_qa_sub: "Wstrzykuj zdarzenia / alerty, aby przetestować pulpit, wysyłkę alertów i kanały powiadomień bez używania prawdziwych urządzeń Moko.",
  admin_qa_event_title: "Wstrzyknij zdarzenie testowe",
  admin_qa_event_sub: "Symuluje webhook urządzenia Moko. Backend uruchomi swój potok wysyłki alertów, tak jakby zdarzenie pochodziło z prawdziwego sprzętu.",
  admin_qa_alert_title: "Wstrzyknij alert testowy",
  admin_qa_alert_sub: "Pomija warstwę zdarzeń i zapisuje alert bezpośrednio. Użyj do testowania dzwonka, listy oraz wysyłki Slack/Telegram.",
  admin_qa_inject_event: "Wstrzyknij zdarzenie",
  admin_qa_inject_alert: "Wstrzyknij alert",
  admin_qa_event_done: "Wstrzyknięto zdarzenie. Obserwuj stronę Zdarzenia i pulpit.",
  admin_qa_alert_done: "Wstrzyknięto alert. Obserwuj dzwonek.",
  admin_qa_disclaimer: "Te punkty końcowe należy wyłączyć lub oflagować w środowisku produkcyjnym.",
  admin_alerts_title: "Polityka alertów",
  admin_alerts_sub: "Reguły alertów obowiązujące w całej {org}. Stosowane do każdego pacjenta tego najemcy.",
  admin_alerts_quiet_title: "Godziny ciszy",
  admin_alerts_quiet_desc: "Określ, kiedy ta organizacja jest w „trybie nocnym”. Przydatne do dyskretniejszego kierowania alertów niekrytycznych.",
  admin_alerts_quiet_hint: "Godziny są interpretowane w lokalnej strefie czasowej organizacji. Zakres może przekraczać północ (np. 22:00 → 06:00).",
  admin_alerts_night_start: "Początek nocy",
  admin_alerts_night_end: "Koniec nocy",
  admin_alerts_load_failed: "Wczytaj politykę alertów",
  admin_alerts_save_failed: "Zapisz politykę alertów",
  admin_alerts_saved: "Zapisano politykę alertów.",
  admin_alerts_clear_title: "Wyczyść aktywne alerty",
  admin_alerts_clear_desc: "Potwierdź jednym kliknięciem wszystkie otwarte alerty w tej organizacji.",
  admin_alerts_clear_hint: "Przydatne po zaplanowanym ćwiczeniu lub źle skonfigurowanym czujniku, który wywołał falę fałszywych alarmów. Potwierdzone alerty pozostają w historii.",
  admin_alerts_ack_all_button: "Potwierdź wszystkie",
  admin_alerts_ack_all_title: "Potwierdzić wszystkie aktywne alerty?",
  admin_alerts_ack_all_confirm: "To oznaczy jako potwierdzony każdy otwarty alert w {org}. Tej akcji nie można cofnąć.",
  admin_alerts_ack_all_done: "Potwierdzono {count} alert(ów).",
  admin_alerts_ack_all_done_generic: "Potwierdzono wszystkie aktywne alerty.",
  admin_alerts_ack_all_failed: "Potwierdź wszystkie alerty",
  org_type_nursing_home: "Dom opieki",
  org_type_assisted_living: "Mieszkanie wspomagane",
  org_type_hospital: "Szpital",
  org_type_home_care: "Opieka domowa",
  role_admin: "Administrator",
  role_caregiver: "Opiekun",
  role_family: "Rodzina",
  status_active: "aktywny",
  status_inactive: "nieaktywny",
  confirm: "Potwierdź",
  sign_in: "Zaloguj się",
  sign_up: "Zarejestruj się",
  email: "E-mail",
  password: "Hasło",
  full_name: "Imię i nazwisko",
  create_account: "Utwórz konto",
  no_account: "Nie masz jeszcze konta?",
  have_account: "Masz już konto?",
  login_welcome: "Witaj ponownie",
  login_sub: "Zaloguj się, aby kontynuować monitorowanie swoich podopiecznych.",
  register_welcome: "Dołącz do E2 Care",
  register_sub: "Utwórz swoją przestrzeń opiekuna w niecałą minutę.",
  total_residents: "Pacjenci",
  active_devices: "Aktywne urządzenia",
  open_alerts: "Otwarte alerty",
  offline_gateways: "Urządzenia offline",
  falls_7d: "Upadki (7 dni)",
  sos_7d: "SOS (7 dni)",
  low_battery: "Niski poziom baterii",
  critical_residents: "Krytyczni",
  status_ok: "Wszystko w porządku",
  status_warning: "Uwaga",
  status_critical: "Krytyczny",
  status_online: "Online",
  status_offline: "Offline",
  search: "Szukaj",
  filter: "Filtruj",
  all: "Wszystkie",
  refresh: "Odśwież",
  loading: "Ładowanie…",
  no_results: "Jeszcze nic tu nie ma.",
  view_profile: "Zobacz profil",
  showing_n_of_m: "Wyświetlanie {n} z {m}",
  load_more: "Wczytaj więcej",
  auto_refresh: "Na żywo · autoodświeżanie",
  auto_refresh_paused: "Wstrzymano (aktywne wczytywanie więcej)",
  updated_just_now: "Zaktualizowano przed chwilą",
  updated_n_sec_ago: "Zaktualizowano {n} s temu",
  updated_n_min_ago: "Zaktualizowano {n} min temu",
  acknowledge: "Potwierdź",
  acknowledged: "Potwierdzono",
  ack_all: "Potwierdź wszystkie",
  ack_all_confirm: "Potwierdzić wszystkie {count} aktywne alerty?",
  ack_all_running: "Potwierdzanie…",
  ack_all_done: "Potwierdzono {count} alert(ów).",
  ack_all_partial: "{ok} potwierdzono · {fail} nie powiodło się.",
  last_seen: "Ostatnio widziano",
  battery: "Bateria",
  signal: "Sygnał",
  firmware: "Oprogramowanie",
  room: "Mieszk. / Pokój",
  age: "Wiek",
  emergency_contact: "Kontakt awaryjny",
  notes: "Notatki",
  assigned_devices: "Przypisane urządzenia",
  recent_events: "Ostatnie zdarzenia",
  timeline_24h: "Ostatnie 24 godziny",
  delivery_status: "Status dostarczenia",
  acknowledged_by: "Potwierdzone przez",
  dashboard_title: "Przegląd domu",
  dashboard_sub: "Szybki obraz wszystkiego, co dzieje się w domach, którymi się opiekujesz.",
  residents_title: "Pacjenci",
  residents_sub: "Osoby, które teraz monitorujesz.",
  devices_title: "Urządzenia",
  devices_sub: "Czujniki i tagi.",
  devices_sub_admin: "Bramki, czujniki i tagi.",
  events_title: "Zdarzenia na żywo",
  events_sub: "Chronologiczny strumień z każdego podłączonego urządzenia.",
  alerts_title: "Alerty",
  alerts_sub: "Powiadomienia eskalowane do rodziny i opiekunów.",
  settings_title: "Ustawienia",
  settings_sub: "Twoje preferencje i reguły powiadomień.",
  users_title: "Zespół",
  users_sub: "Opiekunowie, rodzina i administratorzy z dostępem.",
  falls_chart_title: "Upadki i SOS — ostatnie 7 dni",
  recent_alerts_title: "Ostatnie krytyczne alerty",
  no_alerts: "Brak otwartych alertów. Wszyscy są bezpieczni.",
  event_fall: "Wykryto upadek",
  event_sos: "Naciśnięto przycisk SOS",
  event_door_open: "Otwarto drzwi",
  event_door_close: "Zamknięto drzwi",
  event_inactivity: "Przedłużona bezczynność",
  event_low_battery: "Niski poziom baterii",
  event_offline: "Urządzenie offline",
  event_online: "Urządzenie znów online",
  event_heartbeat: "Sygnał kontrolny",
  event_button_press: "Naciśnięto przycisk",
  device_gateway: "Bramka Bluetooth",
  device_door_sensor: "Czujnik drzwi",
  device_bracelet: "Opaska",
  device_unknown: "Nieznane urządzenie",
  language: "Język",
  notifications: "Powiadomienia",
  quiet_hours: "Godziny ciszy",
  escalation: "Polityka eskalacji",
  just_now: "przed chwilą",
  min_ago: "min temu",
  h_ago: "godz. temu",
  d_ago: "dni temu",
  demo_hint: "Konto demo: admin@e2care.lv / Care2024!",
  open_menu: "Otwórz menu",
  close_menu: "Zamknij menu",
  care_team: "Zespół opieki",
  family_members: "Rodzina",
  no_caregivers: "Nie przypisano jeszcze opiekunów.",
  no_family: "Nie połączono jeszcze członków rodziny.",
  add_caregiver: "Dodaj opiekuna",
  add_family: "Dodaj członka rodziny",
  select_user: "Wybierz użytkownika…",
  cancel: "Anuluj",
  add: "Dodaj",
  remove: "Usuń",
  save: "Zapisz",
  relationship: "Pokrewieństwo",
  relationship_son: "Syn",
  relationship_daughter: "Córka",
  relationship_spouse: "Małżonek",
  relationship_other: "Inne",
  notify_via: "Powiadom przez",
  call_contact: "Zadzwoń do kontaktu",
  view_resident: "Otwórz profil",
  address: "Adres",
  admin_only_section: "Narzędzia administratora",
  rooms_title: "Pokoje",
  rooms_sub: "Każdy nadzorowany pokój — pacjenci, urządzenia i bieżący stan.",
  room_name: "Pokój",
  room_type: "Typ",
  room_type_private_room: "Pokój prywatny",
  room_type_shared_room: "Pokój wspólny",
  room_type_apartment: "Mieszkanie",
  room_type_corridor: "Korytarz",
  room_type_common_area: "Część wspólna",
  room_floor: "Piętro",
  room_state: "Bieżący stan",
  door: "Drzwi",
  window: "Okno",
  door_open_state: "Otwarte",
  door_closed_state: "Zamknięte",
  door_unknown_state: "Nieznany",
  room_no_devices: "W tym pokoju nie ma jeszcze urządzeń.",
  room_no_patients: "Do tego pokoju nie przypisano jeszcze pacjentów.",
  room_patients: "Pacjenci w pokoju",
  room_devices: "Urządzenia w pokoju",
  room_activity: "Oś czasu aktywności",
  rooms_filter_all_types: "Wszystkie typy",
  widget_active_alerts: "Aktywne alerty",
  widget_active_alerts_sub: "Krytyczne, nierozwiązane i potwierdzone",
  widget_patients_status: "Status pacjentów",
  widget_devices_health: "Stan urządzeń",
  widget_room_activity: "Aktywność pokoi",
  widget_recent_events: "Strumień zdarzeń na żywo",
  widget_connectivity: "Łączność",
  metric_critical: "Krytyczne",
  metric_unresolved: "Nierozwiązane",
  metric_acknowledged_count: "Potwierdzone",
  metric_total: "Łącznie",
  metric_active: "Aktywne",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "Oczekujące OTA",
  metric_battery_warn: "Niska bateria",
  metric_doors_open: "Otwarte drzwi",
  metric_windows_open: "Otwarte okna",
  metric_signal_avg: "Śr. sygnał",
  metric_last_comm: "Ostatnia komunikacja",
  metric_packets: "Pakiety / godz.",
  view_all: "Zobacz wszystkie",
  status_new: "Nowy",
  status_acknowledged: "Potwierdzony",
  status_resolved: "Rozwiązany",
  status_resolved_local: "Rozwiązany (lokalnie)",
  resolve: "Rozwiąż",
  add_note: "Dodaj notatkę",
  save_note: "Zapisz notatkę",
  resolve_local_badge: "tylko to urządzenie",
  resolve_local_hint: "Oznacza alert jako rozwiązany tylko w Twojej przeglądarce. Serwer i inni członkowie zespołu nadal widzą go jako otwarty.",
  note_placeholder: "Dodaj kontekst dla zespołu…",
  notes_count: "{n} notatka(-i)",
  device_detail: "Szczegóły urządzenia",
  device_diagnostics: "Diagnostyka",
  device_firmware_history: "Historia oprogramowania",
  device_ota_config: "Konfiguracja OTA",
  device_ota_status: "Status OTA",
  device_signal: "Jakość sygnału",
  device_mac: "Adres MAC",
  device_serial: "Numer seryjny",
  fall_sensitivity: "Czułość wykrywania upadku",
  transmission_interval: "Interwał transmisji",
  low_battery_threshold: "Próg niskiej baterii",
  ota_idle: "Bezczynny",
  ota_pending: "Oczekujący",
  ota_deploying: "Wdrażanie",
  ota_failed: "Niepowodzenie",
  events_filter_severity: "Ważność",
  events_filter_room: "Pokój",
  events_filter_patient: "Pacjent",
  events_filter_device: "Urządzenie",
  severity_info: "Informacja",
  severity_warning: "Ostrzeżenie",
  severity_critical: "Krytyczny",
  telegram_title: "Alerty Telegram",
  telegram_desc: "Otrzymuj alerty na Telegramie dla przypisanych podopiecznych.",
  telegram_connect: "Połącz Telegram",
  telegram_connected: "Telegram połączony",
  telegram_connected_as: "Połączono z Telegramem jako {name}",
  telegram_connect_success: "Pomyślnie połączono Telegram",
  telegram_connect_error: "Nie udało się połączyć Telegrama. Spróbuj ponownie.",
  telegram_missing_bot: "Bot Telegram nie jest skonfigurowany. Ustaw REACT_APP_TELEGRAM_BOT w pliku env.",
  telegram_disconnect: "Rozłącz",
  telegram_disconnect_success: "Rozłączono Telegram.",
  telegram_disconnect_error: "Nie udało się rozłączyć Telegrama. Spróbuj ponownie.",
  telegram_already_linked: "To konto Telegram jest już powiązane z innym użytkownikiem e2-care.",
  telegram_switch_q: "Użyć innego konta Telegram?",
  telegram_switch_intro: "Telegram pamięta, które konto jest zalogowane na wszystkich stronach. Aby użyć innego:",
  telegram_switch_step1: "Otwórz Telegram Web i wyloguj się z bieżącego konta.",
  telegram_switch_step2: "Wróć tutaj i przeładuj poniższy przycisk, a następnie zaloguj się drugim kontem.",
  telegram_open_web: "Otwórz Telegram Web",
  telegram_reload_widget: "Wylogowałem się — przeładuj przycisk",
  lang_autodetected_toast: "Wykryto Twój język jako {language}. Możesz go zmienić w Ustawieniach.",
  admin_view_active: "Aktywne",
  admin_view_archived: "Zarchiwizowane",
  admin_restore: "Przywróć",
  admin_restored: "Przywrócono.",
  admin_hard_delete: "Usuń trwale",
  admin_hard_delete_title: "Usunąć trwale?",
  admin_hard_delete_confirm: "To trwale usunie „{name}” z bazy danych. Tej akcji nie można cofnąć.",
  admin_hard_deleted: "Trwale usunięto.",
  admin_no_archived: "Brak zarchiwizowanych elementów.",
  language_desc: "Używany do interfejsu aplikacji oraz powiadomień Telegram + push.",
  language_saved: "Zaktualizowano język.",
  language_error: "Nie udało się zaktualizować języka. Spróbuj ponownie.",
  admin_field_language: "Język",
  edit: "Edytuj",
  generic_error: "Coś poszło nie tak. Spróbuj ponownie.",
  caregiver_added: "Dodano opiekuna.",
  caregiver_removed: "Usunięto opiekuna.",
  family_added: "Dodano członka rodziny.",
  family_removed: "Usunięto członka rodziny.",
  menu: "Menu",
  dl_companion_app: "Aplikacja towarzysząca",
  dl_hero_title: "E2 Care na Androida",
  dl_hero_sub: "Zainstaluj aplikację towarzyszącą na telefonie z Moko, aby przekazywać alerty, konfigurować urządzenia i pozostać w kontakcie z zespołem opieki — nawet gdy pulpit jest zamknięty.",
  dl_android_apk: "APK Android",
  dl_version_loading: "ładowanie wersji…",
  dl_released: "Wydano {date}",
  dl_download_apk: "Pobierz APK",
  dl_unavailable: "Niedostępne",
  dl_preparing: "Przygotowywanie…",
  dl_manifest_error: "Nie udało się wczytać manifestu. Spróbuj odświeżyć — jeśli problem nie ustępuje, serwer kompilacji może być ponownie wdrażany.",
  dl_whats_new: "Co nowego",
  dl_installing_title: "Instalacja na telefonie",
  dl_step1: "Naciśnij „Pobierz APK” powyżej. Przeglądarka może ostrzec, że pliki APK mogą uszkodzić urządzenie — to ostrzeżenie jest normalne dla każdego instalatora pobranego poza Sklepem Play.",
  dl_step2: "Otwórz pobrany plik. Android poprosi o zezwolenie na instalacje z tej przeglądarki za pierwszym razem — włącz uprawnienie i wróć.",
  dl_step3: "Naciśnij „Zainstaluj”, a następnie „Otwórz” po zakończeniu.",
  dl_step4: "Zaloguj się przy użyciu swoich danych E2 Care.",
  dl_iphone_note: "Wersja na iPhone pojawi się później. Na razie skorzystaj z pulpitu internetowego.",
  dl_back_to_dashboard: "Powrót do pulpitu",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Zmiana organizacji usuwa bieżące przypisanie pokoju i pacjenta.",
  admin_view_full: "Pełna lista",
  device_filter_assignment: "Przypisanie",
  device_filter_patient: "Przypisany do pacjenta",
  device_filter_room: "Przypisany do pokoju",
  device_filter_unassigned: "Nieprzypisany",
  admin_all_orgs: "Wszystkie organizacje",
  pagination_prev: "Poprzednia",
  pagination_next: "Następna",
  pagination_per_page: "Na stronę",
  pagination_page_of: "Strona {page} z {pages}",
  pagination_total: "Łącznie {total}",
};
export default pl;
